(function () {
  if (window.__purchaseProtectionCleanupInit) return;
  window.__purchaseProtectionCleanupInit = true;

  let removalInFlight = false;
  let cartIsClean = false;

  function getConfig() {
    return window.PurchaseProtectionConfig || null;
  }

  function isCheckoutPath() {
    const p = window.location.pathname || '';
    return p.startsWith('/checkout') || p.startsWith('/checkouts');
  }

  function isCartPath() {
    const p = window.location.pathname || '';
    return /(^|\/)cart(\/|$)/.test(p);
  }

  function protectionVariantIds(config) {
    if (!config || !config.variants) return [];
    return [config.variants.t1, config.variants.t2, config.variants.t3, config.variants.t4]
      .map(Number)
      .filter(Number.isFinite);
  }

  async function removeProtectionIfNotCheckout() {
    if (isCheckoutPath()) return;
    if (!isCartPath() && cartIsClean) return;

    const config = getConfig();
    if (!config) return;

    const variantIds = protectionVariantIds(config);
    if (!variantIds.length) return;

    if (removalInFlight) return;
    removalInFlight = true;

    try {
      const cartRes = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });

      if (!cartRes.ok) return;

      const cart = await cartRes.json();

      const hasProtection = (cart.items || []).some(function (item) {
        return variantIds.includes(Number(item.id));
      });

      if (!hasProtection) {
        cartIsClean = true;
        return;
      }

      cartIsClean = false;

      const updates = {};
      variantIds.forEach(function (id) { updates[id] = 0; });

      const updateRes = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });

      if (!updateRes.ok) return;

      window.location.reload();
    } catch (e) {
      console.error('[PP cleanup] error:', e);
    } finally {
      removalInFlight = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeProtectionIfNotCheckout, { once: true });
  } else {
    removeProtectionIfNotCheckout();
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    cartIsClean = false;
    removalInFlight = false;
    removeProtectionIfNotCheckout();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      removeProtectionIfNotCheckout();
    }
  });
})();